import {pageInfo, exportData} from '../api/index';
import {Message} from 'element-ui';

const area = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    exportDataObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    EXPORT_DATA(state, data) {
      state.exportDataObj = data;
    }
  },
  actions: {
    //查询
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //导出
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
  }
}
export default area



// WEBPACK FOOTER //
// ./src/page/mdm/area/store/area.store.js